import type { ReactNode } from 'react';
import { cn } from '../../utils/helpers';

export interface TabItem {
  value: string;
  label: ReactNode;
  count?: number;
  hidden?: boolean;
}

interface TabsProps {
  tabs: TabItem[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

export function Tabs({ tabs, value, onChange, className }: TabsProps) {
  return (
    <div className={cn('-mx-4 overflow-x-auto px-4 sm:mx-0 sm:px-0', className)}>
      <div role="tablist" className="flex min-w-max gap-1 border-b border-secondary-200">
        {tabs
          .filter((tab) => !tab.hidden)
          .map((tab) => {
            const active = tab.value === value;
            return (
              <button
                key={tab.value}
                role="tab"
                type="button"
                aria-selected={active}
                onClick={() => onChange(tab.value)}
                className={cn(
                  '-mb-px inline-flex items-center gap-2 border-b-2 px-3 py-2.5 text-sm font-medium transition-colors focus:outline-none focus-visible:bg-secondary-100',
                  active
                    ? 'border-primary-600 text-primary-700'
                    : 'border-transparent text-secondary-500 hover:border-secondary-300 hover:text-secondary-800',
                )}
              >
                {tab.label}
                {tab.count !== undefined && (
                  <span
                    className={cn(
                      'rounded-full px-1.5 py-0.5 text-xs tabular-nums',
                      active ? 'bg-primary-100 text-primary-700' : 'bg-secondary-100 text-secondary-600',
                    )}
                  >
                    {tab.count}
                  </span>
                )}
              </button>
            );
          })}
      </div>
    </div>
  );
}
